import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DashboardService } from '../../../worklist/services/dashboard.service';
import _ from 'lodash';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service'
import { ThemingService } from '../../../theming/services/theming.service';
import { NavigationService } from '@ispm/dashboard/navigation/services/navigation.service';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import { WebConfigService } from '../../../layout/services/webConfig.service';
import { UserActionCreatorService } from '../../../user/services/user-action-creator.service'
import { EndpointService } from '../../../shared/services/endpoint.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { NavigationConfigService } from '@ispm/dashboard/navigation/services/navigationConfig.service';
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { IEndpoint } from '@ispm/shared/interfaces/endpoint.interface';

@Component({
  selector: 'gen-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardHomeComponent implements OnInit, OnDestroy {
  forTestingPurposesOnly: any;
  forTestingPurposesOnlyMessage: any;
  endpointIspmAdmin: any;
  navSubscriber: any;
  endpointIspmWeb: any;
  stateValue: string;
  user: any;
  showFirstTimePopup: any;
  evaluationAdminImage: any;
  isEmbeddedSubscription: any;
  isEmbedded: boolean;
  @Output() touch = new EventEmitter<string>();
  searchBarEnabled: boolean = false;
  aboutDialogState: string;
  worklistDisabled: boolean;
  curationEnabled: boolean;
  curationWorklistLabel: string;
  currentTab: any;
  organizationLogo: any;
  subscriber: any;
  currentApp: any;
  toggleTools: boolean;
  title: any;
  appId: any;
  appName: any;
  disclaimerConfiguration: any;
  @Input() text: any;
  @Input() approveBtnText;
  hidePartnerBy: any;
  appIconData: any;
  searchParam: string;
  patients: any[];

  item: any;
  ADMIN_URL = '/admin/settings';
  aboutIcon: string;
  navigationItems: any;
  version: any;
  pdfshow: boolean;
  selectedp: any;
  isSearchBoxVisible: boolean;
  private _webConfig: any;
  get webConfig(): any {
    return this._webConfig;
  }
  @Input() set webConfig(webConfig: any) {
    this._webConfig = webConfig;
  };

  constructor(
    private dashboardService: DashboardService,
    private route: Router,
    private coreActionCreatorService: CoreActionCreatorService,
    private themingService: ThemingService,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    private webConfigService: WebConfigService,
    private UserActionCreatorService: UserActionCreatorService,
    private endpointService: EndpointService,
    private navigationConfigService: NavigationConfigService,
    private routerManagerService: RouterManagerService,
    private patientService: PatientService,
    public notificationMessageService: NotificationMessageService
  ) {
console.log("DashboardHomeComponents loader");
  }

  ngOnInit() {
    console.log("DashboardHomeComponents ngOnInit");
    this.searchBoxVisibilty();
    this.webConfig = this.activatedRoute.snapshot?.data?.webConfig;
    this.stateValue = this.route.url;
    this.user = this.authService.user;
    this.showFirstTimePopup = _.get(this._webConfig, 'data.dashboard.disclaimer.showFirstTimePopup') || false;
    this.evaluationAdminImage = _.get(this._webConfig, 'data.aboutBoxContent.evaluationImage') || false;
    const ispmGeneralConfiguration = {};
    const ADMIN_URL = '/admin/settings';
    const isEmbedded$ = this.coreActionCreatorService.isEmbedded();
    // const isEmbeddedSubscription;
    this.navigationConfigService.getCurrentApp().subscribe((app) => {
      if (app.id == "ISPM-ONCO-SIGNAL-APP") {
        this.aboutIcon = "OncoSIGNal__icon__Innosign"
      }
    });
    if (isEmbedded$ && typeof isEmbedded$.subscribe === 'function') {
      this.isEmbeddedSubscription = isEmbedded$.subscribe(
        isEmbedded => this.isEmbedded = isEmbedded
      );
    }
    if (!this.user) {
      this.touch.emit('unauthorized');
    }
    if(this.routerManagerService.currentPageUrl.indexOf(ADMIN_URL) < 0){
      this.searchBarEnabled = true;
    }
    // let currentApp = null;
    this.loadDashboardUiElements(this._webConfig);
    this.aboutDialogState = 'closed';
    this.dashboardService.getClinicalUsageMessage().then((data) => {
      let nonClinicalUsage = data;
      this.forTestingPurposesOnly = nonClinicalUsage ? nonClinicalUsage.forTestingOnly : false;
      this.forTestingPurposesOnlyMessage = nonClinicalUsage && nonClinicalUsage.forTestingOnly ? nonClinicalUsage.message : '';
    });

    this.worklistDisabled = false;
    this.curationEnabled = false;
    this.curationWorklistLabel = 'LAMPP KB';

    this.routerManagerService.getRoutingListenerFor("ResolveEnd").distinctUntilChanged().subscribe(this.checkSearchStatus);

    if (!this.currentTab) {
      //Handles GEN-17703 - selecting last tab after user refreshed the browsergit a
      if (this.stateValue == 'dashboard.curation') {
        this.currentTab = 'curation';
      }
      else {
        this.currentTab = 'worklist';
      }
    }
    if (this.user && !this.user.organization) {
      this.user.organization = sessionStorage.getItem("adminSelectOrganizationId");
    }
    this.subscriber = this.webConfigService.getWebConfiguration().filter(webConfig => webConfig.init).switchMap(webConfig => {
      return this.UserActionCreatorService.getStore().select("organizationConfiguration").map(data => {
        this.organizationLogo = null;
        if (data) {
          this.organizationLogo = data.logo;
        }
        return webConfig;
      });
    }).subscribe(webConfig => {
      // read the appName configuration
      this.loadDashboardUiElements(webConfig);
      this.checkSearchStatus();
    });
    this.navigationItems = this.dashboardService.getNavigationItems();
    const version = this.version;
    if (this.user && this.user.role == 'researcher') {
      this.patientService.getAll().subscribe((patients) => {
        this.patients = patients;
      });
    }
  }
  searchBoxVisibilty() {
    if (this.route['routerState']['snapshot'].url.includes('curation') || this.canShowSearchBox()) {
      this.isSearchBoxVisible = false;
    } else {
      this.isSearchBoxVisible = true;
    }
  }
  ngOnDestroy() {
    if (this.endpointIspmAdmin) {
      this.endpointIspmAdmin.unsubscribe();
    }
    // this.subscriber.unsubscribe();
    if (this.endpointIspmWeb) {
      this.endpointIspmWeb.unsubscribe();
    }
    if (this.navSubscriber != null) {
      this.navSubscriber.unsubscribe();
    }
    if (this.isEmbeddedSubscription) {
      this.isEmbeddedSubscription.unsubscribe();
    }
  }

  loadDashboardUiElements(webConfig) {
    if (webConfig && webConfig.dashboard && webConfig.dashboard.theme) {
      this.themingService.fetchTheme(webConfig.dashboard.theme);
    }
    /* need to add */
    this.showFirstTimePopup = _.get(webConfig, 'dashboard.disclaimer.showFirstTimePopup') || false;
    this.title = _.get(webConfig, 'dashboard.disclaimer.title') || '';
    this.appId = _.get(webConfig, 'currentApp.id');
    this.appName = _.get(webConfig, 'dashboard.appName');

    this.navSubscriber = this.webConfigService.getCurrentApplication()
      .switchMap(app => {
        this.currentApp = app;
        return this.webConfigService.getCurrentAppLocalization(app)
      })
      .subscribe((itm) => {
        if (itm != null && itm.disclaimer != null) {
          this.disclaimerConfiguration = itm.disclaimer;
          this.text = itm.disclaimer.text;
          this.approveBtnText = itm.disclaimer.acknowledge;
          this.title = itm.disclaimer.title;
        } else {
          this.text = _.get(webConfig, 'data.dashboard.disclaimer.text') || _.get(webConfig, 'dashboard.disclaimer.text');
          this.disclaimerConfiguration = _.get(webConfig, 'dashboard.disclaimer', {});
        }
      });


    this.hidePartnerBy = _.get(this._webConfig, 'hidePartnerBy', false);
    let partnerByText = _.get(this._webConfig, 'partnerByText');
    partnerByText = partnerByText ? partnerByText : "Partnered by";

    if (this.appName) {
      // parse the appName data and check if it includes a placeholder of an application icon
      let appLogoPlaceholderParamIndex = this.appName.indexOf('{appLogoPlaceholder}');
      //Remove validation of appLogoPlaceholder check in appname to display branding logo
      this.appIconData = this.organizationLogo ? this.organizationLogo : null;

      if (appLogoPlaceholderParamIndex > -1) {
        this.appName = this.appName.substring(0, appLogoPlaceholderParamIndex); // extract the original appName, without the placeholder
      }
    }
  }

  checkSearchStatus() {
    if (this.navigationService) {
      this.searchBarEnabled = this.appId ? this.navigationService.getStateSearchBar(false, this.appId) : false;
    }
  }
  canShowSearchBox() {
    return this.route.routerState.snapshot.url.indexOf('admin') !== -1;
  }

  closeLogOutMenu() {
    this.toggleTools = !this.toggleTools;
  }
  isOrgAdminActionsAllowed() {
    return (
      (
        this.authService.doesUserHasPermission('ADMIN.PORTAL.ACCESS') ||
        this.authService.doesUserHasPermission('REPORTTEMPLATE.READ') ||
        this.authService.doesUserHasPermission('REPORTTEMPLATE.WRITE') ||
        this.authService.doesUserHasPermission('REPORTTEMPLATE.CREATE') ||

        this.authService.doesUserHasPermission('DOCKER.READ') ||
        this.authService.doesUserHasPermission('DOCKER.WRITE') ||
        this.authService.doesUserHasPermission('DOCKER.CREATE') ||

        (this.authService.user && this.authService.user.role.toLowerCase() === 'genomicsadmingroup')
      )
    );
  }
  goAdminHome() {
    this.endpointService.getGenomicsIspmAdminEndpoint()
      .subscribe((data: IEndpoint) => window.open(data.endpoint + this.ADMIN_URL + '?source=clinical&u-code=' + encodeURIComponent(this.user.xsrf), '_blank'),
        () => this.toggleTools = false
      );
  }
  logout() {
    if (!localStorage.getItem('webEndPoint')) { // this part needs for the logout from the client side when u appear here from the admin side
      this.endpointService.getGenomicsWebEndpoint().subscribe(
        (res: IEndpoint) => {
          localStorage.setItem("webEndPoint", res.endpoint);
          this.authService.logout({refresh: true})
        }
      );
    } else {
      this.authService.logout({refresh: true});
    }
  }
  isAdminMicroService() {
    return window.location['pathname'].includes(this.ADMIN_URL)
  }
  isDataModelToolAccess() {
    return this.authService.doesUserHasPermission('DATAMODELTOOL.ACCESS');
  }
  goOrgAdminSettings() {
    this.authService.user.organization = this.authService.user.originalOrganization;
    this.route.navigate(['admin/home']);
  }
  openDatamodelTool() {
    this.route.navigate(['/admin/settings/dashboard/datamodel'],{ relativeTo: this.activatedRoute });
  }
  getUserNameTooltip() {
    return this.getFullUserName();
  }
  getFullUserName() {
    const given = _.get(this, 'user.info.name[0].given[0]');
    const family = _.get(this, 'user.info.name[0].family[0]');

    return (given + " " + family).trim();
  }
  nameTooltipEnabled() {
    var nameElem = document.getElementById("dash-fullname");
    return nameElem.scrollWidth > nameElem.clientWidth;
  }

  goHome() {
    this.route.navigate(['dashboard']);
  }
  refreshState() {
    // need to change the state as part of PathHomeComponent 'pathHomeRoute'
    this.route.navigate(['Pathologist']);
    this.currentTab = 'worklist';
  }
  openCuration() {
    this.route.navigate(['curation']);
    this.currentTab = 'curation';
  }
  openPathways() {
    this.route.navigate(['Pathologist/PatientProfile/pathways']);
    this.currentTab = 'pathways';
  }
  isActive(viewLocation) {
    return this.activatedRoute.snapshot.url.includes[viewLocation];
  }
  pdfShow(id) {
    this.pdfshow = false;
    this.selectedp = id;
    setTimeout(() => {
      this.pdfshow = true;
    }, 50);
  }

  selectPatient(patient) {
    this.route.navigate(['Pathologist/'], { queryParams: {
        patientId: patient.id,
        testId: "",
        revisionId: ""
      }
    });
    this.searchParam = "";
    this.patients = [];
  }

  isTestActionsAllowed() {
    return this.authService.doesUserHasPermission('TEST.WRITE');
  }

  isCaseSearchAllowed() {
    return this.authService.doesUserHasPermission('WORKFLOW.READ');
  }
  search(str) {
    this.patients = [];
    this.patientService.getAll(str).subscribe( (patients)=> {
      this.patients = patients;
      this.patients.forEach((val, key) => {
        val.fullName = val.name[0].given[0] + ' ' + val.name[0].family[0];
      });
    });
  }
  openValuesetTool() {
    this.route.navigate(['/admin/settings/dashboard/basevalueset'], {relativeTo: this.activatedRoute});
  }
}
